import { VStack } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigationBlockerContext } from "src/components/NavigationBlocker";
import { SegmentedControl } from "src/components/SegmentedControl";
import { useEnrollmentPeriodContext } from "../Edit";
import { EnrollmentSchoolsGradesView } from "./EnrollmentSchoolsGradesView";
import { OfferingCategoriesPanel } from "./offeringCategories/OfferingCategoriesPanel";
import { OfferingsPanel } from "./offerings/OfferingsPanel";

export const EnrollmentSchoolsTab: React.FC = () => {
  const { enrollmentPeriod } = useEnrollmentPeriodContext();

  if (enrollmentPeriod.use_service_offerings) {
    return <EnrollmentSchoolsOfferingsView />;
  }

  return <EnrollmentSchoolsGradesView />;
};

enum OfferingsViewMode {
  Categories = "categories",
  Offerings = "offerings",
}

const EnrollmentSchoolsOfferingsView: React.FC = () => {
  const { confirm, hasChanges } = useNavigationBlockerContext();
  const [view, setView] = useState<OfferingsViewMode>(
    OfferingsViewMode.Offerings
  );

  const handleViewChange = async (nextView: OfferingsViewMode) => {
    if (nextView === view) return;
    if (hasChanges && !(await confirm())) return;
    setView(nextView);
  };

  return (
    <VStack align="stretch" gap={4}>
      <SegmentedControl
        options={[
          {
            label: "Offerings",
            value: OfferingsViewMode.Offerings,
          },
          {
            label: "Offering categories",
            value: OfferingsViewMode.Categories,
          },
        ]}
        value={view}
        onChange={handleViewChange}
      />
      {view === OfferingsViewMode.Categories ? (
        <OfferingCategoriesPanel />
      ) : (
        <OfferingsPanel
          onGoToOfferingCategories={() => setView(OfferingsViewMode.Categories)}
        />
      )}
    </VStack>
  );
};
